// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3UZrU","rootSuccess":"CompleteLink_rootSuccess__2rQHr","rootFailure":"CompleteLink_rootFailure__2agY6","isDisabled":"CompleteLink_isDisabled__12Nqy"};